import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctValueList } from '../../../../Fct/generics';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PRICE_ORACLE_ADDRESSES } from '../constants';
export var GetAssetsPrices = createPlugin({
    protocol: 'AAVE',
    type: 'ORACLE',
    method: 'getAssetsPrices',
    supportedContracts: PRICE_ORACLE_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    assets: new FctAddressList({ options: getAaveTokens({ chainId: chainId }) }),
                },
            },
            output: {
                prices: new FctValueList({ destination: 'amount_list' }),
            },
        });
    },
});
